import { Helmet } from 'react-helmet';

interface ITitle {
  title?: string;
}

// Product name is jurisdiction-aware: AU → "CoE Shield", everywhere
// else → "CAS Shield". Read directly from `window.globalConfig`
// (populated by the env-variables Lambda@Edge from the per-host
// ENV_VARIABLES row's `jurisdiction` field). Avoids importing i18next
// here — shared-components is consumed by Remix (student-apply) and
// React-router-v7 apps that don't declare i18next as a dep, so the
// import was breaking their Vite/Rollup build.
//
// SSR safe: `typeof window` guard means server-side renders get the
// default "CAS Shield" value, which matches the static `<title>` in
// each app's index.html. React Helmet replaces the static title
// client-side once the component mounts.
function readProductName(): string {
  if (typeof window === 'undefined') return 'CAS Shield';
  const cfg = (window as { globalConfig?: { jurisdiction?: string } }).globalConfig;
  return cfg?.jurisdiction === 'AU' ? 'CoE Shield' : 'CAS Shield';
}

export const Title = (props: ITitle) => {
  const { title } = props;
  const productName = readProductName();

  return (
    <Helmet titleTemplate={`%s - ${productName}`}>
      <title>{title}</title>
    </Helmet>
  );
};
